module.exports = __webpack_public_path__ + "img/download-bottom.c236a42c.svg";